import axios from 'axios'
import store from '../vuex/store';
import Cookies from 'js-cookie'
import router from '../router'
import {
  Message
} from 'element-ui'

const service = axios.create({
  // baseURL: '/index.php',
  withCredentials: true,
  xsrfCookieName: 'X-Token',
  baseURL: process.env.BASE_Console_Login_Domain,
  timeout: 50000, // 请求超时时间
  headers: {
    'X-Server-Name': '71360'
  }
})

// request拦截,在请求发起
service.interceptors.request.use((config) => {
  if (Cookies.get('X-Token') && Cookies.get('X-Token') !== undefined) {
    config.headers['X-Token'] = Cookies.get('X-Token')
  }
  return config
})

// respone拦截,获取请求数据后
service.interceptors.response.use(
  // 正常获取数据
  response => {
    if (response.data && response.data.code == 200) {
      return response.data
    } else {
      if (response.data.code === 401 || response.data.code === 101) {
        router.push('/login')
        store.commit('app/set_login_dialog_isShow',true)
      } else if (response.data.code === 510) {
        // 510位表单验证不通过时 去报errorList里的内容
        Message.error(response.data.errorList[0].errorInfo)
      } else if (response.data.code > 200 && response.data.code < 300) {
        // 不显示报错弹框
        if (response.data.code === 211) {
          // 忘记密码和注册情况
          router.push('/login')
          store.commit('app/set_login_dialog_isShow',true)
        }
      } else {
        Message.error(response.data.message)
      }
      return Promise.reject(response.data)
    }
  },
  // 请求失败
  error => {
    return Promise.reject('error', error)
  },
)

export default service



// WEBPACK FOOTER //
// ./src/base/console_login.js